import { get, post, put, getAbs } from "./http";
import { orderBucket } from "../utils/status";

// Mirrors ordr-flutter Repository bid/order calls
export const createBidRequest = (payload) => post("/buyer/bidRequest", payload).then(afterChange);
// payload: { locationId, productId, orderSize, deliveryDate: "YYYY-MM-DD", deliveryTime, otherNotes }

// The v3 listing joins several collections per order, so a big page easily outlasts the default 30s.
export const getOrdersListing = (pageNo = 0, limit = 20) => getAbs("/v3/buyer/orders/list", { pageNo, limit }, undefined, 90000);

// The v2 /buyer/orders endpoint only knows "bidRequest" — every other orderType falls back to
// delivered orders, and "Order completed" (34) is in no bucket. Like ordr-flutter, fetch every
// order from the v3 listing and bucket by bidRequestState on the client instead.
const PAGE_SIZE = 100;
const ORDERS_TTL_MS = 20000;
let ordersCache = null;

// Anything that creates or changes an order must call this so the lists don't show stale data.
export const invalidateOrders = () => {
	ordersCache = null;
};

const afterChange = (res) => {
	invalidateOrders();
	return res;
};

// The sidebar, dashboard and orders page all need the full list at once; share a single fetch.
export function getAllOrders() {
	if (ordersCache && Date.now() - ordersCache.at < ORDERS_TTL_MS) return ordersCache.promise;
	const promise = fetchAllOrders().then((res) => {
		if (res?.error && ordersCache?.promise === promise) ordersCache = null;
		return res;
	});
	ordersCache = { promise, at: Date.now() };
	return promise;
}

async function fetchAllOrders() {
	const all = [];
	for (let pageNo = 0; ; pageNo++) {
		const res = await getOrdersListing(pageNo, PAGE_SIZE);
		// An empty page comes back as error: true with data: [] — only a missing body is a real failure.
		if (!res || !Array.isArray(res.data)) return res || { error: true, data: null };
		const page = res.data;
		all.push(...page);
		if (page.length < PAGE_SIZE) break;
	}
	return { error: false, data: all };
}

export async function getOrdersByType(orderType) {
	const res = await getAllOrders();
	if (res.error) return res;
	return { error: false, data: res.data.filter((o) => orderBucket(o.bidRequestState) === orderType) };
}

export const getOrderDetails = (orderId) => get(`/buyer/bidRequest/${orderId}`);

export const updateBidRequestStatus = (bidRequestId, payload) =>
	put(`/buyer/bidRequest/status/${bidRequestId}`, payload).then(afterChange);

export const increaseOrderQty = (payload) => post("/buyer/order/increaseQty", payload).then(afterChange);

export const getTopThreeBids = (bidRequestId) => get(`/buyer/topBidRequest/${bidRequestId}`);

export const awardBid = (payload) => post("/buyer/bidAwardation", payload).then(afterChange);
// payload: { bidRequestId, sellerId } (awards a seller's bid — accepting one of the top 3)

export const cancelBidRequest = (orderId, payload) =>
	post(`/buyer/bidCancellationRequest/${orderId}`, payload).then(afterChange);

export const repeatOrder = (payload) => post("/buyer/repeat-order", payload).then(afterChange);
